var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{ref:"table",attrs:{"columns":_vm.columns,"data":_vm.list,"max-height":700},scopedSlots:_vm._u([{key:"status",fn:function(ref){
var row = ref.row;
return [_c('a',[_vm._v(_vm._s(row.status))]),_c('br'),_c('a',{staticClass:"scoped-error"},[_vm._v(_vm._s(row.breakdown))])]}},{key:"status_time",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.status_time)),_c('br'),_vm._v(" "+_vm._s(row.breakdown_time)+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }